import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { requests } from "../../common/RestAPI";
import { generateQueryParam } from "../../common/util";
import { PLATFORM_URL } from "../../value/Url";
import ContentsProps from "../../interfaceTypes/ContentsProps";
import { AuditLogSystemData, auditLogDetailModalContent, tableHeaders } from "./AuditLogData";
import AuditLogMgmt from "./AuditLogMgmt";


export default function AuditLogMgmtContainer(props:ContentsProps) {
    const { t } = useTranslation();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const fetchIdRef = useRef(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [tableData, setTableData] = useState<AuditLogSystemData[]>([]);
    const [refreshYn, setRefreshYn] = useState(false);

    const headers = useMemo(() => tableHeaders, []);
    const navigate = useNavigate();


    useEffect(() => {
        AlertFunction('');
    }, []);


    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }


    function executeSystemAuditList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading) {
        if(showLoading) {
            setCurrentPage(pageIndex);
            props.setLoading(true);
        }
        requests.get(PLATFORM_URL.AUDIT_LOG, generateQueryParam(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search))
        .then((response) => {
            if (response.status === 200 && response.data.items && pageIndex === response.data.page-1) {
                setTableData(response.data.items);
                setPageCount(response.data.pages);
                setTotalItemCount(response.data.total);
            }
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
        .catch((error) => {
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
    }

    const fetchData = useCallback(({ pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading }) => {
        const fetchId = ++fetchIdRef.current
        if(fetchId === fetchIdRef.current) {
            executeSystemAuditList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading);
        }
    }, []);


    function clickRow(item) {
        props.showSlideModalCb({...auditLogDetailModalContent, openYn: true, resultCb: (v)=>{}, args: item});
    }

    return (
        <AuditLogMgmt
            fetchData={fetchData}
            clickRow={clickRow}
            currentPage={currentPage}
            pageCount={pageCount}
            headers={headers}
            tableData={tableData}
            totalItemCount={totalItemCount}
            refreshYn={refreshYn}
            infoText={infoText}
            infoError={infoError}
        />
    )
}